import { call, put } from "redux-saga/effects";

import { actions, api } from ".";

export const deck = {
  * get() {
    try {
      const response = yield call(api.get);
      const payload = response ? response.data : {};

      yield put(actions.get.success(payload));
    } catch (error) {
      yield put(actions.get.error(error));
    }
  },
};
